import React from "react";
import Header from "./components/header";
import Message from "./components/message";
// import "antd/dist/antd.css";

const App: React.FC = () => {
  return (
    <div
      className="w-[100vw] h-[100vh] overflow-hidden flex flex-col "
      style={{
        background: `url(${require("./static/bg.png")})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        overflow: "hidden",
      }}
    >
      <Header />
      <Message />
    </div>
  );
};

export default App;
